// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"MiddleTable_headerWrapper__2J0g7","buttonWrapper":"MiddleTable_buttonWrapper__sC3oV","footerWrapper":"MiddleTable_footerWrapper__1zbIR"};